var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContentPlanIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48",
    strokeWidth: 3,
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21 25L33 25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M16 25H15"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21 34H29"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M16 34H15"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.0026 8.56201C9.86637 8.67177 8.88387 8.78726 8.05131 8.89823C5.85219 9.19137 4.1737 10.8462 3.85898 13.0423C3.45142 15.8862 3 20.4106 3 26.4999C3 32.5892 3.45142 37.1136 3.85898 39.9575C4.1737 42.1536 5.85219 43.8084 8.0513 44.1015C11.1817 44.5188 16.4319 44.9999 24 44.9999C31.5681 44.9999 36.8183 44.5188 39.9487 44.1015C42.1478 43.8084 43.8263 42.1536 44.141 39.9575C44.5486 37.1136 45 32.5892 45 26.4999C45 20.4106 44.5486 15.8862 44.141 13.0423C43.8263 10.8462 42.1478 9.19137 39.9487 8.89823C39.1161 8.78726 38.1336 8.67177 36.9974 8.56201"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M29.0001 8.07403C27.4622 8.02711 25.7964 8 24 8C22.2036 8 20.5379 8.02711 19 8.07403"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M29.0131 9.26993C29.0564 11.3499 30.4217 12.9643 32.5019 12.9963C32.6608 12.9987 32.8267 13 33 13C33.1733 13 33.3392 12.9987 33.4981 12.9963C35.5783 12.9643 36.9436 11.3499 36.9869 9.26993C36.9951 8.87467 37 8.45026 37 8C37 7.54974 36.9951 7.12533 36.9869 6.73007C36.9436 4.65009 35.5783 3.03574 33.4981 3.00374C33.3392 3.0013 33.1733 3 33 3C32.8267 3 32.6608 3.0013 32.5019 3.00374C30.4217 3.03574 29.0564 4.65009 29.0131 6.73007C29.0049 7.12533 29 7.54974 29 8C29 8.45026 29.0049 8.87467 29.0131 9.26993Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.0131 9.26993C11.0564 11.3499 12.4217 12.9643 14.5019 12.9963C14.6608 12.9987 14.8267 13 15 13C15.1733 13 15.3392 12.9987 15.4981 12.9963C17.5783 12.9643 18.9436 11.3499 18.9869 9.26993C18.9951 8.87467 19 8.45026 19 8C19 7.54974 18.9951 7.12533 18.9869 6.73007C18.9436 4.65009 17.5783 3.03574 15.4981 3.00374C15.3392 3.0013 15.1733 3 15 3C14.8267 3 14.6608 3.0013 14.5019 3.00374C12.4217 3.03574 11.0564 4.65009 11.0131 6.73007C11.0049 7.12533 11 7.54974 11 8C11 8.45026 11.0049 8.87467 11.0131 9.26993Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentPlanIcon);
export default __webpack_public_path__ + "static/media/content-plan-icon.87a33f86eb133b132b60f530dc7876ff.svg";
export { ForwardRef as ReactComponent };